var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStatus75 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 12C4.5 13.4834 4.93987 14.9334 5.76398 16.1668C6.58809 17.4001 7.75943 18.3614 9.12987 18.9291C10.5003 19.4968 12.0083 19.6453 13.4632 19.3559C14.918 19.0665 16.2544 18.3522 17.3033 17.3033C18.3522 16.2544 19.0665 14.918 19.3559 13.4632C19.6453 12.0083 19.4968 10.5003 18.9291 9.12987C18.3614 7.75943 17.4001 6.58809 16.1668 5.76398C14.9334 4.93987 13.4834 4.5 12 4.5V12L4.5 12Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStatus75);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/status-75.e29a7a0c737981a3ade8191ed54641e9.svg";